/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */

import { useCallback, useEffect } from "react";
import "./brochurerender.scss";

const BrochureRenderer = ({ brochure }) => {
	const renderPDFFromFile = useCallback((brochure) => {
		window.$("#flipbookContainer").empty();
		window.$("#flipbookContainer").flipBook(brochure);
	}, []);

	useEffect(() => {
		renderPDFFromFile(brochure);
	}, [brochure, renderPDFFromFile]);

	return (
		<div className="brochure-container">
			<div id="flipbookContainer" style={{ margin: "auto" }}></div>
		</div>
	);
};

export default BrochureRenderer;
